import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import store from "../store/index.js";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import("../views/HomeView.vue")
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    // Vista OTP post-login (requiere pending2fa en sessionStorage)
    path: '/verificar-2fa',
    name: 'Verificar2FA',
    component: () => import("../views/Verificar2FA.vue")
  },
  {
    path: "/ForgotPassword",
    name: "ForgotPassword",
    component: () => import("../views/ForgotPassword.vue")
  },
  {
    path: "/ResetPassword/:token/:email",
    name: "ResetPassword",
    component: () => import("../views/ResetPassword.vue")
  },
  {
    path: "/CambiarClave/:email",
    name: "CambiarClave",
    component: () => import("../views/ResetPassword.vue")
  },
  // Ciclo operativo (también registrables vía menus/componentes_rutas)
  {
    path: "/centros-costo",
    name: "CentrosCosto",
    component: () => import("../views/flota/centrosCosto/CentroCostoIndex.vue"),
  },
  {
    path: "/personal-operativo",
    name: "PersonalOperativo",
    component: () => import("../views/flota/personal/PersonalIndex.vue"),
  },
  {
    path: "/huella-carbono",
    name: "HuellaCarbono",
    component: () => import("../views/flota/reportes/HuellaCarbonoIndex.vue"),
  },
  {
    path: "/viajes-operativos",
    name: "ViajesOperativos",
    component: () => import("../views/flota/viajesOperativos/ViajesOperativosIndex.vue"),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const publicNames = ["Login", "ForgotPassword", "ResetPassword", "CambiarClave", "Verificar2FA"];
  if (!publicNames.includes(to.name) && !store.getters.isAuthenticated) {
    next({ name: "Login" });
    return;
  }
  // 2FA: sin challenge pendiente no se permite la pantalla de verificación
  if (to.name === "Verificar2FA") {
    try {
      const pending = JSON.parse(sessionStorage.getItem("pending2fa") || "null");
      if (!pending?.challenge_id) {
        next({ name: "Login" });
        return;
      }
    } catch (e) {
      next({ name: "Login" });
      return;
    }
  }
  next();
})

export default router
